import { render } from "./InvoiceSecondaryTitle.vue?vue&type=template&id=1839826c"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1839826c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1839826c', script)) {
    api.reload('1839826c', script)
  }
  
  module.hot.accept("./InvoiceSecondaryTitle.vue?vue&type=template&id=1839826c", () => {
    api.rerender('1839826c', render)
  })

}

script.__file = "src/views/payments/modules/pageTitles/InvoiceSecondaryTitle.vue"

export default script